import { BaseStatementPagePath } from "app/core/workflow/page-path/statement-page-path/base-statement-page.path";

export class TaxDocumentsComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return "statement/:statementId/tax-documents";
  }

  public static regex(): RegExp {
    return /(\/statement\/)\d+(\/tax-documents)((\/?#?)|(\/?#.*?))$/;
  }
}
